import { Api } from 'apis';

export type NewBackgroundCheckBody = {
	checkType: Array<string>;
	email: string;
	requested_countries: Array<string>;
};

export type CountryPrices = {
	country: string;
	short_code: string;
	price: number;
};

export async function postBackgroundCheckV2(body: NewBackgroundCheckBody) {
	const response = await Api.post(`/api/backgoundCheck`, body);
	return response.data;
}

export async function getBillingInfo() {
	return await Api.get(`/auth/get-billing-info`);
}

type CardSession = {
	session_url: string;
};

export async function getCardSession(params?: {
	partner_integration?: boolean;
}) {
	const queryParams = new URLSearchParams();
	if (params?.partner_integration) {
		queryParams.append('partner_integration', 'true');
	}

	const url = `/auth/card-session${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
	return await Api.get<CardSession>(url);
}

export async function getCountryPrices() {
	return (
		await Api.get<Array<CountryPrices>>('/api/fetch-international-countries')
	).data;
}
